/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA (40)`)
};

const es_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARNss (40)`)
};

const de_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA (40)`)
};

const nl_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA (40)`)
};

const fr_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARNsb (40)`)
};

const it_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA (40)`)
};

const pt_br2_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA (40)`)
};

const pt_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssARN (40)`)
};

const ja_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA (40)`)
};

const zh_od_ssrna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssRNA（40）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_ssrna = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_ssrna(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_ssrna", locale)
	if (locale === "en") return en_od_ssrna(inputs)
	if (locale === "es") return es_od_ssrna(inputs)
	if (locale === "de") return de_od_ssrna(inputs)
	if (locale === "nl") return nl_od_ssrna(inputs)
	if (locale === "fr") return fr_od_ssrna(inputs)
	if (locale === "it") return it_od_ssrna(inputs)
	if (locale === "pt-BR") return pt_br2_od_ssrna(inputs)
	if (locale === "pt") return pt_od_ssrna(inputs)
	if (locale === "ja") return ja_od_ssrna(inputs)
	return zh_od_ssrna(inputs)
};